/**
 * New state management system
 * Replaces the monolithic 'a' object with focused state classes
 */

// Export the main app state
export { appState, AppState, a } from './AppState';

// Export individual state classes
export { BaseState } from './BaseState';
export { DrawingState } from './DrawingState';
export { UIState } from './UIState';
export { InteractionState } from './InteractionState';
export { ViewState } from './ViewState';
export { DrawingModeState } from './DrawingModeState';
export { NetworkState } from './NetworkState';
export { SettingsState } from './SettingsState';

// Export compatibility layer for existing functions
export * from './CompatibilityLayer';
